import { Link } from "react-router-dom";
import { NewProductCategoryGrid } from "../../Layout/Common/newproductCategoryGrid";
import { isValidArray } from "../../Layout/Common/common";
import { Fragment, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { PAGES } from "../../routeConfig";

export const NewProductCategoryContainer = () => {
  const { newCategoryData } = useContext(GlobalContext);
  return (
    <Fragment>
      {isValidArray(newCategoryData) && (
        <section className="products-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h2>Latest Product Releases</h2>
                  <Link to={PAGES.NEWPRODUCTS_CT} className="text-decoration-underline text-uppercase">
                    View All
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="row row-spacing">
                  {newCategoryData.map((row, index) => (
                    <NewProductCategoryGrid key={row.id || index} row={row} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
